import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Acluxuryurbaniahireinmahabaleshwar() {



    const cardData =
    {
        keyword: 'AC Luxury Urbania Hire in Mahabaleshwar',
        heading: 'Urbania on rent in pune: AC Luxury Urbania Hire in Mahabaleshwar',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable AC Luxury Urbania Hire in Mahabaleshwar for families, corporate groups, tourists, and event travelers planning comfortable and stylish travel to the scenic hill station of Mahabaleshwar. Our well-maintained luxury Force Urbania fleet provides spacious seating, powerful air-conditioning, plush interiors, and smooth performance, making it ideal for weekend getaways, corporate outings, airport transfers, weddings, sightseeing tours, and outstation journeys from Pune to Mahabaleshwar. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a refined, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for AC luxury Urbania hire to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is the heart of Mahabaleshwar and one of its most visited attractions. Surrounded by dense forests and hills, the lake offers boating, horse riding, and leisure walks along its scenic pathways. Visitors can enjoy paddle boats, row boats, and lakeside snacks while soaking in the cool climate. In the evenings, the area becomes lively with food stalls, shopping kiosks, and misty surroundings, making it a perfect family-friendly spot to relax and unwind."
  },
  {
    "title": "Arthur’s Seat Point",
    "description": "Arthur’s Seat, often called the ‘Queen of all viewpoints,’ offers breathtaking views of deep valleys and the Savitri River gorge. The point is famous for its unique optical illusion where objects appear to float due to air pressure changes. With sharp cliffs, cool winds, and panoramic scenery, it is a paradise for photographers and nature lovers. The dramatic landscape makes it one of the most iconic viewpoints in Mahabaleshwar."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a popular food and leisure destination known for its strawberry-based products, chocolates, pizzas, and fresh juices. Surrounded by greenery, it offers a pleasant environment for families and tourists to relax. The garden hosts the annual Strawberry Festival, attracting visitors from across Maharashtra. Shopping for jams, syrups, and souvenirs makes it a must-visit spot for food lovers."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point is the highest point in Mahabaleshwar and the best place to witness stunning sunrises. Offering a 360-degree view of the surrounding hills and valleys, it is especially popular during early mornings when mist covers the landscape. The peaceful atmosphere and cool breeze make it ideal for meditation, photography, and nature appreciation. It is also one of the few points open early in the morning."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is named after a rock formation resembling the head of an elephant. It provides magnificent views of the Sahyadri mountain range and deep valleys below. The cool winds, lush greenery, and dramatic cliffs make it a refreshing stop for visitors. It is especially popular during monsoon when clouds float through the valley, creating a magical experience."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is one of the most beautiful waterfalls in the Mahabaleshwar region, especially during the monsoon season. The waterfall plunges from a great height, creating mist and rainbows in the sunlight. Visitors can enjoy scenic viewpoints, short treks, and nature photography. The surrounding greenery and sound of cascading water make it a soothing natural retreat."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort is a historic hill fort located near Mahabaleshwar, famous for the battle between Chhatrapati Shivaji Maharaj and Afzal Khan. The fort offers panoramic views of forests and valleys, along with temples and historical structures inside. A statue of Shivaji Maharaj stands proudly at the top, attracting history enthusiasts and devotees. It is a perfect blend of history, architecture, and natural beauty."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Mahabaleshwar Temple is an ancient temple dedicated to Lord Shiva and is the spiritual heart of the hill station. Built in Hemadpanthi architectural style, the temple houses a sacred Shiva lingam and is believed to be the source of five rivers, including Krishna. The calm atmosphere, stone carvings, and religious significance make it an important pilgrimage site for devotees."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani is a nearby hill station known for its pleasant climate, tableland, and colonial charm. The vast Table Land offers breathtaking views and activities like horse riding and paragliding. Strawberry farms, boarding schools, and scenic viewpoints add to its charm. It is often visited along with Mahabaleshwar as part of a combined hill-station tour."
  },
  {
    "title": "Kate’s Point and Needle Hole Point",
    "description": "Kate’s Point offers spectacular views of the Krishna Valley and Dhom Dam backwaters. Nearby Needle Hole Point, also known as Elephant’s Head Point view, showcases a naturally carved rock formation. The strong winds, vast open views, and layered mountains make it a favorite among photographers. Sunsets here are especially mesmerizing."
  },
  {
    "title": "Bombay Point (Sunset Point)",
    "description": "Bombay Point is one of the best locations in Mahabaleshwar to enjoy colorful sunsets. Overlooking the old route to Mumbai, the point provides wide views of valleys and distant hills. As the sun sets, the sky turns shades of orange and pink, attracting crowds of tourists. It is a peaceful spot ideal for evening relaxation and photography."
  }
],






"services": [
{
"name": "AC Luxury Urbania Hire in Mahabaleshwar",
"description": "AC Luxury Urbania Hire in Mahabaleshwar offers premium air-conditioned Urbania buses specially suited for hill station travel. These luxury buses feature plush seating, spacious interiors, powerful AC for all weather conditions, and professional chauffeurs, ensuring a smooth, safe, and comfortable journey through the scenic roads of Mahabaleshwar."
},
{
"name": "Mahabaleshwar Luxury Urbania Rental",
"description": "Mahabaleshwar Luxury Urbania Rental provides high-end Urbania buses for tourists, families, and corporate travelers. With elegant interiors, modern amenities, and reliable drivers experienced in hill routes, this service ensures a refined and stress-free travel experience."
},
{
"name": "Premium AC Urbania Mahabaleshwar",
"description": "Premium AC Urbania Mahabaleshwar delivers an upscale travel experience with climate-controlled comfort, smooth suspension, and ample legroom. Ideal for sightseeing tours, leisure trips, and premium group travel in and around Mahabaleshwar."
},
{
"name": "Urbania AC Luxury Bus Mahabaleshwar",
"description": "Urbania AC Luxury Bus Mahabaleshwar offers fully air-conditioned luxury buses designed for winding hill roads and long-distance journeys. Passengers enjoy quiet cabins, comfortable seating, and experienced chauffeurs for a relaxed hill station journey."
},
{
"name": "Corporate Luxury Urbania Hire Mahabaleshwar",
"description": "Corporate Luxury Urbania Hire Mahabaleshwar provides premium transport solutions for business meetings, corporate retreats, conferences, and team outings. The service focuses on punctuality, professionalism, and executive-level comfort."
},
{
"name": "Luxury Urbania for Hill Station Trip Mahabaleshwar",
"description": "Luxury Urbania for Hill Station Trip Mahabaleshwar is ideal for navigating scenic routes with comfort and safety. These buses offer stable performance on slopes, spacious seating, and luxury interiors, making hill travel enjoyable and worry-free."
},
{
"name": "Chauffeur Driven Luxury Urbania Mahabaleshwar",
"description": "Chauffeur Driven Luxury Urbania Mahabaleshwar ensures a stress-free journey with trained, verified drivers experienced in hill driving. Perfect for families, tourists, and corporate groups seeking safety, comfort, and professional service."
},
{
"name": "Wedding Luxury Urbania Mahabaleshwar",
"description": "Wedding Luxury Urbania Mahabaleshwar offers elegant and spacious luxury buses for transporting wedding guests to hill station venues. Adds comfort, style, and convenience to destination weddings and special celebrations."
},
{
"name": "Family Tour Luxury Urbania Mahabaleshwar",
"description": "Family Tour Luxury Urbania Mahabaleshwar provides comfortable and luxurious travel for family vacations, sightseeing, and holiday trips. Spacious interiors and smooth rides ensure enjoyable journeys for all age groups."
},
{
"name": "Best Luxury Urbania Rental Mahabaleshwar",
"description": "Best Luxury Urbania Rental Mahabaleshwar is known for top-quality buses, clean interiors, courteous staff, and dependable service. Ideal for tourists and premium travelers seeking the best travel experience in Mahabaleshwar."
},
{
"name": "Executive Urbania Hire Mahabaleshwar",
"description": "Executive Urbania Hire Mahabaleshwar caters to senior executives, VIP guests, and corporate delegations. Features luxury interiors, privacy, and professional chauffeurs for a premium and dignified travel experience."
},
{
"name": "Comfortable Luxury Urbania Mahabaleshwar",
"description": "Comfortable Luxury Urbania Mahabaleshwar focuses on providing fatigue-free travel with ergonomic seating, ample legroom, smooth suspension, and refined interiors, even on long hill station routes."
},
{
"name": "High End Urbania Rental Mahabaleshwar",
"description": "High End Urbania Rental Mahabaleshwar offers exclusive luxury buses for travelers seeking superior quality, advanced features, and reliable service for premium hill station travel."
},
{
"name": "Trusted Luxury Urbania Service Mahabaleshwar",
"description": "Trusted Luxury Urbania Service Mahabaleshwar is recognized for safety, reliability, and consistent service quality. Customers trust this service for professional drivers, well-maintained buses, and hassle-free luxury travel."
},
{
"name": "Tourist Luxury Urbania Mahabaleshwar",
"description": "Tourist Luxury Urbania Mahabaleshwar provides premium Urbania buses for sightseeing and tourist travel. Ideal for exploring viewpoints, attractions, and nearby destinations with comfort, elegance, and experienced chauffeurs."
}
],
"tableData": [
["AC Luxury Urbania Hire in Mahabaleshwar", "Mahabaleshwar Luxury Urbania Rental"],
["Premium AC Urbania Mahabaleshwar", "Urbania AC Luxury Bus Mahabaleshwar"],
["Corporate Luxury Urbania Hire Mahabaleshwar", "Luxury Urbania for Hill Station Trip Mahabaleshwar"],
["Chauffeur Driven Luxury Urbania Mahabaleshwar", "Wedding Luxury Urbania Mahabaleshwar"],
["Family Tour Luxury Urbania Mahabaleshwar", "Best Luxury Urbania Rental Mahabaleshwar"],
["Executive Urbania Hire Mahabaleshwar", "Comfortable Luxury Urbania Mahabaleshwar"],
["High End Urbania Rental Mahabaleshwar", "Trusted Luxury Urbania Service Mahabaleshwar"],
["Tourist Luxury Urbania Mahabaleshwar", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "AC Luxury Urbania Hire in Mahabaleshwar",
        "WhyChoosedescription": "AC Luxury Urbania Hire in Mahabaleshwar is perfect for group travel, family trips, corporate outings, weddings, and hill station tours, offering premium comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Luxury AC Urbania",
        "WhyChoosedescription": "AC Luxury Urbania Hire in Mahabaleshwar provides modern Force Urbania buses with air-conditioning, plush pushback seats, ample legroom, ambient lighting, and premium interiors for a luxurious travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "AC Luxury Urbania Hire in Mahabaleshwar comes with skilled drivers familiar with Mahabaleshwar, Pune, Satara, and nearby routes, ensuring safe, smooth, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Choose AC Luxury Urbania Hire in Mahabaleshwar for fair pricing with no hidden charges, making premium group travel affordable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "AC Luxury Urbania Hire in Mahabaleshwar offers round-the-clock booking assistance and customer support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "AC Luxury Urbania Hire in Mahabaleshwar is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, weddings, and customized travel plans."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All buses under AC Luxury Urbania Hire in Mahabaleshwar are regularly cleaned, sanitized, and maintained to ensure passenger safety, hygiene, and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "AC Luxury Urbania Hire in Mahabaleshwar ensures on-time pickups and dependable service, providing a seamless and stress-free luxury travel experience."
    }
]
}

const faqData = [
    {
        question: 'Are AC Luxury Urbania Hire in Mahabaleshwar available for local and outstation travel?',
        answer: 'Yes, AC Luxury Urbania Hire in Mahabaleshwar can be booked for city travel, hill station tours, corporate outings, weddings, and long-distance journeys.',
    },
    {
        question: 'How can I book AC Luxury Urbania Hire in Mahabaleshwar?',
        answer: 'You can book AC Luxury Urbania Hire in Mahabaleshwar via phone, WhatsApp, or online booking for fast and easy reservations.',
    },
    {
        question: 'Why choose AC Luxury Urbania Hire in Mahabaleshwar?',
        answer: 'AC Luxury Urbania Hire in Mahabaleshwar offers premium interiors, spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for AC Luxury Urbania Hire in Mahabaleshwar are licensed, trained, and experienced in handling luxury Force Urbania buses safely.',
    },
    {
        question: 'Can pickup and drop-off locations be customized?',
        answer: 'Absolutely. AC Luxury Urbania Hire in Mahabaleshwar allows flexible pickup and drop locations across Mahabaleshwar and nearby areas.',
    },
    {
        question: 'Are AC Luxury Urbania Hire in Mahabaleshwar available 24x7?',
        answer: 'Yes, AC Luxury Urbania Hire in Mahabaleshwar operates 24x7 for all travel requirements.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'AC Luxury Urbania Hire in Mahabaleshwar accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can AC Luxury Urbania be used for corporate, weddings, and group trips?',
        answer: 'Yes, AC Luxury Urbania Hire in Mahabaleshwar is ideal for corporate events, weddings, family outings, and hill station tours.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Patil',
        feedback: 'AC Luxury Urbania Hire in Mahabaleshwar provided an excellent and comfortable ride for our family hill station trip. Highly recommended.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Kulkarni',
        feedback: 'We booked AC Luxury Urbania Hire in Mahabaleshwar for a corporate outing. The bus was luxurious, clean, and very comfortable.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rohit Deshpande',
        feedback: 'AC Luxury Urbania Hire in Mahabaleshwar made our group travel smooth, comfortable, and stress-free. Excellent service.',
        rating: 5,
    },
];































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Luxury Urbania Hire in Mahabaleshwar",
  "image": "https://urbaniaonrentpune.in/assets/images/luxury-urbania-mahabaleshwar.jpg",
  "description": "AC Luxury Urbania Hire in Mahabaleshwar offers premium AC Urbania buses for hill station trips, corporate travel, weddings, family tours, executive outings, and outstation journeys. Chauffeur-driven luxury Urbania buses ensure superior comfort, safety, and a smooth travel experience across Mahabaleshwar and nearby tourist destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/ac-luxury-urbania-hire-mahabaleshwar"
  }
};










    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | AC Luxury Urbania Hire in Mahabaleshwar | Premium Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book AC Luxury Urbania Hire in Mahabaleshwar for hill station trips, corporate travel, weddings, family tours, and executive outings. Premium AC Urbania buses with chauffeur-driven service deliver a comfortable, safe, and luxury travel experience in Mahabaleshwar."
  />

  <meta
    name="keywords"
    content="AC Luxury Urbania Hire in Mahabaleshwar, Mahabaleshwar Luxury Urbania Rental, Premium AC Urbania Mahabaleshwar, Urbania AC Luxury Bus Mahabaleshwar, Corporate Luxury Urbania Hire Mahabaleshwar, Luxury Urbania for Hill Station Trip Mahabaleshwar, Chauffeur Driven Luxury Urbania Mahabaleshwar, Wedding Luxury Urbania Mahabaleshwar, Family Tour Luxury Urbania Mahabaleshwar, Best Luxury Urbania Rental Mahabaleshwar, Executive Urbania Hire Mahabaleshwar, Comfortable Luxury Urbania Mahabaleshwar, High End Urbania Rental Mahabaleshwar, Trusted Luxury Urbania Service Mahabaleshwar, Tourist Luxury Urbania Mahabaleshwar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Acluxuryurbaniahireinmahabaleshwar;